import React, { useState } from 'react';
import { useUrlSearchParams } from "use-url-search-params";
import { useTranslation } from "react-i18next";

import { useFunctionTasks } from "modules/functionRegister/hooks";

import { Breadcrumb, Table } from 'antd';

import Pagination from "containers/Pagination";

import Title from "components/Title";
import Spacer from "components/Spacer";
import Container from "components/Container";

import FilterList from "./components/FilterList";

import { renderTextWithLink } from "lib/renderTextWithLink";

const FunctionTasks = () => {
    const { t, i18n } = useTranslation();

    const [params, setParams] = useUrlSearchParams();
    const [search, setSearch] = useState(0);

    const defaultParams = {
        search,
        page: params.page,
        perPage: params.perPage,
        filter: [
            {
                key: `name`,
                operation: "%_%",
                value: params.name,
                type: "STRING",
            },
            {
                key: "organization_id",
                operation: "=",
                value: params.organization_id,
                type: "NUMBER",
            }
        ],
    }

    const { items: functionTasks, meta, isFetched: isFunctionTasksFetched } = useFunctionTasks({
        params: defaultParams,
    });

    return (
        <Container>
            <Spacer size={35} />

            <Breadcrumb separator=">">
                <Breadcrumb.Item href='/'>{t('home')}</Breadcrumb.Item>
                <Breadcrumb.Item >{t('function_tasks')}</Breadcrumb.Item>
            </Breadcrumb>

            <Spacer size={32} />

            <Title align='left' text={t('function_tasks')} />

            <Spacer size={40} />

            <FilterList {...{ params, setParams, setSearch }} />
            <Spacer size={20} />

            <Table
                rowKey="id"
                defaultSort="-id"
                columns={[
                    {
                        title: "№",
                        render: (_, __, index) =>
                            (meta.current - 1) * meta.perPage + index + 1,
                    },
                    {
                        key: "name",
                        title: t("column_function_task_name"),
                        dataIndex: "name",
                    },
                    {
                        key: "organization",
                        title: t("column_organization"),
                        dataIndex: ["organization", "name", i18n.language],
                    },
                     {
                        key: "description",
                        title: t("column_function_description"),
                        dataIndex: ["description"],
                    },
                ]}
                dataSource={functionTasks}
                pagination={false}
                loading={!isFunctionTasksFetched}
            />

            <Spacer size={32} />

            <Pagination
                current={meta.current}
                perPage={meta.perPage}
                total={meta.totalPages}
                currentItems={functionTasks.length}
                totalItems={meta.totalItems}
                onChange={(page) => setParams({ page })}
                onPerPageChange={perPage => setParams({ perPage })}
            />

            <Spacer size={140} />
        </Container>
    )
}

export default FunctionTasks;